import { Type } from 'class-transformer';

import { IPagination, IQueryPaginationDto } from './utils';

export class RegionTransferTypesCreate {
  name: string;
  finish_date: string;
  routes: {
    cikis_bolge_point_id: string;
    varis_bolge_point_id: string;
    saat_tahmini: string;
    gercek_saat: string;
    driver_id: string;
    route_id: string | null;
  }[];
}

export class RegionTransferTypesUpdate {
  name?: string;
  finish_date?: string;
  routes?: {
    cikis_bolge_point_id: string;
    varis_bolge_point_id: string;
    saat_tahmini: string;
    gercek_saat: string;
    driver_id: string;
    route_id: string | null;
  }[];
}

export class RegionTransferTypesQueryDto extends IQueryPaginationDto {
  name?: string;
}

export class RegionTransferTypes {
  id: string;
  name: string;
  finish_date: string;
  routes: {
    cikis_bolge_point_id: string;
    varis_bolge_point_id: string;
    saat_tahmini: string;
    gercek_saat: string;
    driver_id: number;
    route_id: string;
  }[];
  createdAt: string;
}

export class RegionTransferTypesResponse {
  @Type(() => RegionTransferTypes)
  result: RegionTransferTypes;
}

export class RegionTransferTypesListResponse extends IPagination {
  @Type(() => RegionTransferTypes)
  results: RegionTransferTypes[];
}
